module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-01.e6282f2a.png";